var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-page',[_c('div',{staticClass:"sub-visual sub-visual--sv5"},[_c('v-container',[_c('h2',{staticClass:"sub-visual__title"},[_c('span',[_vm._v("PRICING")])])])],1),_c('PriceList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }